import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from '@appkit4/angular-components/button';
import { TabsModule } from '@appkit4/angular-components/tabs';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { GridModule } from '@shared/modules/grid/grid.module';
import { RichEditorModule } from '@shared/modules/rich-editor/rich-editor.module';
import { UiCommonModule } from '@shared/modules/ui-common/ui-common.module';
import { SharedModule } from '@shared/shared.module';
import { CountryHomeComponent } from './components/country-home/country-home.component';
import { CountryInformationEditorComponent } from './components/country-information-editor/country-information-editor.component';
import { TaxNewsCardComponent } from './components/tax-news-card/tax-news-card.component';
import { TaxNewsEditorComponent } from './components/tax-news-editor/tax-news-editor.component';
import { TaxNewsComponent } from './components/tax-news/tax-news.component';
import { TaxRateSummariesBoxComponent } from './components/tax-rate-summaries-box/tax-rate-summaries-box.component';
import { TaxRateSummariesContainerComponent } from './components/tax-rate-summaries-container/tax-rate-summaries-container.component';
import { TaxRatesSummariesComponent } from './components/tax-rates-summaries/tax-rates-summaries.component';
import { TaxSummaryEditorComponent } from './components/tax-summary-editor/tax-summary-editor.component';
import { CountryInformationRoutingModule } from './country-information-routing.module';
import { CountryInformationService } from './services/country-information.service';
import { TaxNewsService } from './services/tax-news.service';
import { TaxSummaryService } from './services/tax-summary.service';

@NgModule({
  declarations: [
    CountryHomeComponent,
    TaxRatesSummariesComponent,
    TaxNewsComponent,
    TaxNewsCardComponent,
    CountryInformationEditorComponent,
    TaxRateSummariesContainerComponent,
    TaxRateSummariesBoxComponent,
    TaxSummaryEditorComponent,
    TaxNewsEditorComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule,
    CountryInformationRoutingModule,
    TranslateDirective,
    TranslatePipe,
    ButtonModule,
    TabsModule,
    RichEditorModule,
    UiCommonModule,
    GridModule,
  ],
  exports: [TaxNewsCardComponent],
  providers: [CountryInformationService, TaxSummaryService, TaxNewsService],
})
export class CountryInformationModule {}
